export class AppStartUpToken {
  static IAppStartUpRepository = Symbol("IAppStartUpRepository");
  static AppStartUpUseCase = Symbol("AppStartUpUseCase");
}
